import { Cable, Sparkles } from 'lucide-react'

export default function ApiConnectPageHeader({ stats }) {
  return (
    <div className="group relative overflow-hidden rounded-2xl p-[1px] shadow-[0_1px_3px_rgba(15,23,42,0.04)] transition-shadow duration-500 hover:shadow-[0_12px_40px_-18px_rgba(37,99,235,0.18)] dark:shadow-none dark:hover:shadow-[0_12px_40px_-18px_rgba(37,99,235,0.25)]">
      <span
        aria-hidden
        className="pointer-events-none absolute inset-[-130%] z-0 animate-[spin_8s_linear_infinite] bg-[conic-gradient(from_0deg,transparent_0deg,transparent_296deg,rgba(37,99,235,0.22)_318deg,rgba(14,165,233,0.34)_336deg,rgba(99,102,241,0.22)_350deg,transparent_360deg)] opacity-70 motion-reduce:animate-none motion-reduce:opacity-50 dark:opacity-40"
      />

      <header className="relative overflow-hidden rounded-[15px] border border-slate-500 bg-white p-6 dark:border-slate-600 dark:bg-slate-900 sm:p-8">
        <div
          className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-gradient-to-br from-brand-500/10 to-cyan-400/10 blur-2xl dark:from-brand-500/20 dark:to-cyan-400/15"
          aria-hidden
        />
        <div
          className="pointer-events-none absolute -bottom-20 left-1/3 h-40 w-40 rounded-full bg-gradient-to-tr from-violet-500/8 to-transparent blur-2xl dark:from-violet-500/15"
          aria-hidden
        />

        <div className="relative flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl shrink-0">
            <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-brand-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-brand-700 ring-1 ring-brand-100 dark:bg-brand-500/10 dark:text-brand-300 dark:ring-brand-500/20">
              <Cable className="h-3.5 w-3.5" aria-hidden />
              Connectivity Center
            </div>
            <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white sm:text-[28px]">
              Digital Connections
            </h1>
            <p className="mt-2 text-sm leading-relaxed text-slate-500 dark:text-slate-400 sm:text-[15px]">
              Explore and manage logistics integrations across carriers, EDI partners,
              customs filing, finance, and tracking.
            </p>
          </div>

          <div className="grid w-full grid-cols-3 gap-3 sm:gap-2.5 lg:ml-auto lg:w-auto lg:max-w-[min(100%,28rem)]">
            {[
              { label: 'Total Integrations', value: stats.total, tone: 'text-brand-600 dark:text-brand-400' },
              { label: 'Active Connections', value: stats.active, tone: 'text-emerald-600 dark:text-emerald-400' },
              { label: 'EDI Partners', value: `${stats.ediPartners}`, tone: 'text-violet-600 dark:text-violet-400' },
            ].map((s) => (
              <div
                key={s.label}
                className="rounded-xl border border-slate-500 bg-slate-50/50 px-3 py-2.5 text-center dark:border-slate-600 dark:bg-slate-800/50 sm:px-4 sm:py-3"
              >
                <div className={`text-xl font-bold tabular-nums sm:text-2xl ${s.tone}`}>
                  {s.value}
                </div>
                <div className="mt-0.5 text-[10px] font-medium leading-tight text-slate-500 dark:text-slate-400 sm:text-[11px]">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        <p className="relative mt-5 flex items-center gap-1.5 text-[11px] text-slate-400 dark:text-slate-500">
          <Sparkles className="h-3.5 w-3.5 text-brand-500 dark:text-brand-400" aria-hidden />
          Curated marketplace of enterprise-grade logistics connectivity modules
        </p>
      </header>
    </div>
  )
}
